module.exports = __webpack_public_path__ + "img/add.d98c856c.svg";